import FormService from '../../services/FormService';
export default {
    data() {
        return {
            content: '',
            form: new FormService({
                name: '',
                weight: '',
                step: '',
                default_price_for_step: '',
                service_options: [],
                percent: null,
                pricing_type: 1,
                free_baggage_allowance_international: 0,
                free_baggage_allowance_local: 0,
                max_baggage_allowance_international: 0,
                max_baggage_allowance_local: 0,
            }),
            isSending: false,

            addBaggageModel: [
                {
                    id: null,
                    distance: null,
                    price_before_distance: null,
                }
            ],
            isFilled: false,
            baggageModelErrors: [],
            onBaggageModelInput: false,
            pricingTypes: {
                TYPE_FIXED_PRICE: 1,
                TYPE_PER_KM_PRICE: 2,
                TYPE_PERCENT_PRICE: 3,
            }
        };
    },

    methods: {
        save() {

            this.isSending = true;
            this.form.service_options = this.addBaggageModel;
            this.submitForm(this.$route.params['id']);

        },
        handleRow(key){
            let model = this.addBaggageModel;
            this.onBaggageModelInput = true;
            if(model.length > 0 &&
                model[key].distance && model[key].distance.length > 0 &&
                model[key].price_before_distance &&
                model[key].price_before_distance.length > 0 &&
                model.length === key + 1
            )
                this.addBaggageModel.push({
                    id:null,
                    distance: null,
                    price_before_distance: null
                });
            // if(model.length > 1 && !model[key].distance && !model[key].price_before_distance) {
            //     model.splice(key + 1, 1);
            //     model.splice(key, 1);
            // }

        },
        handleRowByBackSpaceButton(){
            length = 0;
            if(this.form.pricing_type == this.pricingTypes.TYPE_PER_KM_PRICE && this.addBaggageModel.length > 1 && this.onBaggageModelInput){
                length = this.addBaggageModel.length - 1;
                this.addBaggageModel.splice(length, 1);
            }
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
        baggageInputs(){
            this.onBaggageModelInput = false;
        },

        submitForm(id){

            let method = 'post';
            let url = this.route('api.baggage.store');

            if(id && id.length > 0){
                url = this.route('api.baggage.update', {id: id});
            }

            this.form.submit(method, url)
                .then(res => {

                    if (!res.errors) {
                        this.$router.push('/baggage');
                    } else {
                        console.log(res.errors);
                    }

                })

        }

    },

    mounted() {

    },

    created() {
        Object.freeze(this.pricingTypes);
        let id = this.$route.params['id'];
        if (id) {
            this.$api.get('baggage.edit', id)
                .then(res => {
                    let service_options = res.data.baggage_service_options;
                    this.form.setData(res.data);
                    this.addBaggageModel = service_options;
                })
        }
        window.addEventListener('keydown', (e) => {
           if(e.which === 8){
               this.handleRowByBackSpaceButton();
           }
        });
    },

    watch: {}

};
